import { add, format } from "date-fns";
import { useState } from "react";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { CreditoDetalles } from "../../../functions/Validaciones/CreditoDetalles";
import { SaldoCuotas } from "../../../functions/Validaciones/CuotasSaldo";
import AlertSuccess from "../../CustomAlerts/AlertSuccess";
import { clienteAxios, useAlerta, useHistory } from "../../shared";
import { BotoneraForm, Input, TextArea } from "../../shared/FormsElements";
import { formatNumber } from "../../../utils/numberFormatter";
import "./styles/FormCreditoEspecial.css";
import "../../shared/styles/UnifiedTable.css";

const FormCreditoEspecial = (props) => {
  let id;
  let id_persona;

  if (props.match.params.id) {
    id = props.match.params.id;
  } else {
    id = null;
  }

  if (props.match.params.idpersona) {
    id_persona = props.match.params.idpersona;
  } else {
    id_persona = null;
  }

  const history = useHistory();

  const [setAlerta, MostrarAlerta] = useAlerta(null);
  const [tasa_generica, setTasaGenerica] = useState(null);
  const [form_persona, setFormPersona] = useState({
    id: null,
    estado: "",
    fecha_analisis: "",
    fecha_vencimiento: "",
    id_persona: null,
    ingresos: "",
    limite: "",
    limite_x_cuota: "",
    nombre: "",
    apellido: "",
    nro_documento: "",
    observacion: "",
    premium: "",
    solicito: "",
    veraz: "",
    bcra: "",
    bienes: "",
    dgr: "",
    referencias_personales: "",
    precalificacion: null,
    garantes: null,
    creditos: null,
  });
  const [form_credito, setFormCredito] = useState({
    interes_total: 0,
    interes: 0,
    capital: 0,
    total: 0,
    cuotas: 0,
    monto: 0,
    producto: "",
    comentarios: "",
    estado: "Vigente",
    vencimiento: "",
    fecha_finalizacion: "",
    fecha_otorgamiento: "",
    interes_moratorio: "",
    interes_punitorio: "",
    saldo_limite_cuota: 0,
    tipo_impresion: "1",
    credito_detalle: [],
  });

  const CalculoMoratoria = (
    interes_mora,
    capital,

    fecha_actual,
    fecha_vencimiento
  ) => {
    //Punitorios
    let interes_punitorio = 0;
    let diferencia_moratoria = 0;

    //Formatear fecha actual
    fecha_actual = format(fecha_actual, "yyyy-MM-dd").toString();
    fecha_actual = new Date(fecha_actual + " 00:00:00").getTime();
    //Fecha de vencimiento de cuota
    let vto = new Date(fecha_vencimiento + " 00:00:00").getTime();
    //Calculo de moratoria
    diferencia_moratoria = fecha_actual - vto;
    diferencia_moratoria = diferencia_moratoria / (1000 * 60 * 60 * 24);

    if (diferencia_moratoria > 0) {
      interes_punitorio = capital * (interes_mora / 100);
      interes_punitorio = interes_punitorio / 30;

      //intereses punitorios
      interes_punitorio = interes_punitorio * diferencia_moratoria;
    }

    return {
      p_interes: interes_punitorio,
      p_moratoria: diferencia_moratoria,
    };
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      //Persona
      case "id":
        {
        }
        break;
      //Credito
      case "interes":
        {
          setFormCredito({
            ...form_credito,
            [e.target.name]: e.target.value,
            total: parseFloat(e.target.value) + parseFloat(form_credito.capital),
          });

          if (
            form_credito.vencimiento.trim() != "" &&
            form_credito.cuotas > 0
          ) {
            let cuotas = form_credito.cuotas;
            let result = [];
            let monto = 0;
            let interes = 0;
            let deuda = 0;
            let importe_devolver = 0;

            let fecha_vto = "";

            for (let i = 0; i < cuotas; i++) {
              let interes = parseFloat(e.target.value);
              let capital = parseFloat(form_credito.capital);
              let total = parseFloat(
                parseFloat(e.target.value) + parseFloat(form_credito.capital)
              );

              const hoy = new Date();
              const vto = new Date(
                form_credito.vencimiento.replace("-", "/") + " 00:00:00"
              );

              if (i == 0) {
                fecha_vto = format(vto, "yyyy-MM-dd").toString();
              } else {
                fecha_vto = format(
                  add(new Date(fecha_vto + " 00:00:00"), { months: 1 }),
                  "yyyy-MM-dd"
                ).toString();
              }

              let { p_interes, p_moratoria } = CalculoMoratoria(
                tasa_generica["PUNITORIO"].valor + tasa_generica["MORATORIA"].valor,
                capital,

                hoy,
                fecha_vto
              );

              deuda = parseFloat(total) + parseFloat(p_interes) + deuda;

              let cuota = {
                nro: i + 1,
                vto: fecha_vto,
                interes: interes,
                capital: capital,
                total: total,
                diferencia_dias: p_moratoria < 0 ? 0 : p_moratoria,
                interes_punitorio: p_interes,
                deuda: deuda,
              };

              monto = parseFloat(monto) + parseFloat(capital);
              importe_devolver = parseFloat(importe_devolver) + parseFloat(total);

              result.push(cuota);
            }

            setFormCredito({
              ...form_credito,
              [e.target.name]: e.target.value,
              total:
                parseFloat(e.target.value) + parseFloat(form_credito.capital),
              credito_detalle: result,
              monto: monto,
              interes_total: importe_devolver,
            });
          }
        }
        break;
      case "capital":
        {
          setFormCredito({
            ...form_credito,
            [e.target.name]: e.target.value,
            total:
              parseFloat(e.target.value) + parseFloat(form_credito.interes),
          });

          if (
            form_credito.vencimiento.trim() != "" &&
            form_credito.cuotas > 0
          ) {
            let cuotas = form_credito.cuotas;
            let result = [];
            let monto = 0;
            let deuda = 0;
            let importe_devolver = 0;

            let fecha_vto = "";

            for (let i = 0; i < cuotas; i++) {
              let interes = parseFloat(e.target.value);
              let capital = parseFloat(form_credito.capital);
              let total = parseFloat(
                parseFloat(e.target.value) + parseFloat(form_credito.capital)
              );

              const hoy = new Date();
              const vto = new Date(
                form_credito.vencimiento.replace("-", "/") + " 00:00:00"
              );

              if (i == 0) {
                fecha_vto = format(vto, "yyyy-MM-dd").toString();
              } else {
                fecha_vto = format(
                  add(new Date(fecha_vto + " 00:00:00"), { months: 1 }),
                  "yyyy-MM-dd"
                ).toString();
              }

              let { p_interes, p_moratoria } = CalculoMoratoria(
                tasa_generica["PUNITORIO"].valor + tasa_generica["MORATORIA"].valor,
                capital,

                hoy,
                fecha_vto
              );

              deuda = parseFloat(total) + parseFloat(p_interes) + deuda;

              let cuota = {
                nro: i + 1,
                vto: fecha_vto,
                interes: interes,
                capital: capital,
                total: total,
                diferencia_dias: p_moratoria < 0 ? 0 : p_moratoria,
                interes_punitorio: p_interes,
                deuda: deuda,
              };

              monto = parseFloat(monto) + parseFloat(capital);
              importe_devolver = parseFloat(total) + parseFloat(importe_devolver);

              result.push(cuota);
            }

            setFormCredito({
              ...form_credito,
              [e.target.name]: e.target.value,
              total:
                parseFloat(e.target.value) + parseFloat(form_credito.interes),
              credito_detalle: result,
              monto: monto,
              interes_total: importe_devolver
            });
          }
        }
        break;
      case "comentarios":
      case "producto":
      case "total":
      case "fecha_otorgamiento":
      case "vencimiento":
      case "monto":
        {
          setFormCredito({
            ...form_credito,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "cuotas":
        {
          if (form_credito.vencimiento.trim() == "") {
            return Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Debe seleccionar una fecha de vencimiento valida",
            });
          }

          if (form_credito.total == 0) {
            return Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "El capital de la cuota debe ser mayor a 0",
            });
          }

          let cuotas = e.target.value;
          let result = [];
          let monto = 0;
          let deuda = 0;
          let importe_devolver = 0;

          let fecha_vto = "";

          for (let i = 0; i < cuotas; i++) {
            let interes = parseFloat(form_credito.interes);
            let capital = parseFloat(form_credito.capital);
            let total = parseFloat(form_credito.total);


            const hoy = new Date();
            const vto = new Date(
              form_credito.vencimiento.replace("-", "/") + " 00:00:00"
            );

            if (i == 0) {
              fecha_vto = format(vto, "yyyy-MM-dd").toString();
            } else {
              fecha_vto = format(
                add(new Date(fecha_vto + " 00:00:00"), { months: 1 }),
                "yyyy-MM-dd"
              ).toString();
            }


            let { p_interes, p_moratoria } = CalculoMoratoria(
              parseFloat(tasa_generica["PUNITORIO"].valor) +  parseFloat(tasa_generica["MORATORIA"].valor),
              capital,

              hoy,
              fecha_vto
            );

            deuda = parseFloat(total) + parseFloat(p_interes) + deuda;

            let cuota = {
              nro: i + 1,
              vto: fecha_vto,
              interes: interes,
              capital: capital,
              total: total,
              diferencia_dias: p_moratoria < 0 ? 0 : p_moratoria,
              interes_punitorio: p_interes,
              deuda: deuda,
            };

            monto = parseFloat(monto) + parseFloat(capital);
            importe_devolver = parseFloat(total) + parseFloat(importe_devolver);

            result.push(cuota);
          }

          setFormCredito({
            ...form_credito,
            [e.target.name]: e.target.value,
            credito_detalle: result,
            monto: monto,
            interes_total: importe_devolver,
          });
        }
        break;
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "guardar":
        {
          let formDetalle = [];
          let vencimiento = "";

          form_credito.credito_detalle.map((detalle, index) => {
            let form = {
              pagoCapital: detalle.capital,
              pagoInteres: detalle.interes,
              cuota: detalle.total,
              fechaFinFormat: detalle.vto,
            };

            if (index == form_credito.credito_detalle.length - 1) {
              vencimiento = detalle.vto;
            }

            formDetalle.push(form);
          });

          let formData = {
            id_persona: id_persona,
            id_tasa: null,
            interes: null,
            monto: form_credito.monto,
            cuotas: form_credito.cuotas,
            garante: "",
            producto: form_credito.producto,
            vencimiento: form_credito.vencimiento,
            estado: "Vigente",
            fecha_finalizacion: vencimiento,
            fecha_otorgamiento: form_credito.fecha_otorgamiento,
            comentarios: form_credito.comentarios,
            interes_moratoria: tasa_generica["MORATORIA"].valor,
            interes_punitorio: tasa_generica["PUNITORIO"].valor,
            tipo_impresion: form_credito.tipo_impresion,

            detalleCredito: formDetalle,
          };

          const result = await clienteAxios.post(
            "/PersonaCreditos/add",
            formData
          );

          AlertSuccess({
            message: "Credito creado",
          });

          return history.push(
            "/creditos/especial/nuevo/" + id_persona + "/" + result.data.id
          );
        }
        break;
    }
  };

  useEffect(() => {
    const fetch = async () => {
      if (id_persona) {
        const result = await clienteAxios.get("/persona/getonepersona", {
          params: { id: id_persona },
        });
        setFormPersona(result.data.personas[0]);
      }

      if (id && tasa_generica) {
        const result = await clienteAxios.get("/PersonaCreditos/get", {
          params: { id: id },
        });

        const credito = result.data.credito;
        const credito_detalle = result.data.detalle;
        let detalles = [];
        let deuda = 0;


        credito_detalle.map((detalle, index) => {
          const hoy = new Date();

          let { p_interes, p_moratoria } = CalculoMoratoria(
            parseFloat(credito.interes_moratoria) + parseFloat(credito.interes_punitorio),
            parseFloat(detalle.capital),

            hoy,
            detalle.fecha_vencimiento
          );

          deuda = parseFloat(detalle.total) + parseFloat(p_interes) + deuda;

          let cuota = {
            nro: index + 1,
            vto: detalle.fecha_vencimiento,
            interes: detalle.interes,
            capital: detalle.capital,
            total: detalle.total,
            diferencia_dias: p_moratoria < 0 ? 0 : p_moratoria,
            interes_punitorio: p_interes,
            deuda: deuda,
          };

          detalles.push(cuota);
        });

        setFormCredito({
          interes_total: parseFloat(credito.interes) + parseFloat(credito.monto),
          interes: detalles.length > 0 ? detalles[0].interes : 0,
          capital: detalles.length > 0 ? detalles[0].capital : 0,
          total: detalles.length > 0 ? parseFloat(detalles[0].interes) + parseFloat(detalles[0].capital) : 0,
          cuotas: credito.cuotas,
          monto: credito.monto,
          producto: credito.producto || "",
          comentarios: credito.comentarios || "",
          estado: credito.estado,
          vencimiento: credito.vencimiento,
          fecha_finalizacion: credito.fecha_finalizacion,
          fecha_otorgamiento: credito.fecha_otorgamiento,
          interes_moratorio: credito.interes_moratoria,
          interes_punitorio: credito.interes_punitorio,
          saldo_limite_cuota: 0,
          tipo_impresion: credito.tipo_impresion,
          credito_detalle: detalles,
        });
      }
    };

    fetch();
  }, [id_persona, id, tasa_generica]);

  useEffect(() => {
    const fetch = async () => {
      const result = await clienteAxios.get("/tasasGenericas/getAll");
      let tasas = {};

      result.data.tasasGenericas.map((tasa) => {
        tasas = {
          ...tasas,
          [tasa.tipo]: tasa,
        };
      });

      setTasaGenerica(tasas);
    };

    fetch();
  }, []);

  //console.log(form_persona);
  //console.log(form_credito);
  //console.log(form_persona);
  //console.log(form_credito)
  return (
    <div className="credit-form-container">
      <div className="container-md">
        <div className="credit-form-header">
          <h1 className="credit-form-title">Gestión de Crédito Especial</h1>
        </div>

        <div className="row">
        <div className="col-md-5">
          <div className="client-info-card">
            <ul className="list-group">
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Nombre</div>
                <div className="client-info-value">
                  {form_persona.apellido + " " + form_persona.nombre}
                </div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Nro Documento</div>
                <div className="client-info-value">{form_persona.nro_documento}</div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Promedio</div>
                <div className="client-info-value">
                  {form_persona.precalificacion
                    ? form_persona.precalificacion.promedio
                    : "-"}
                </div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Estado</div>
                <div className="client-info-value">
                  {form_persona.precalificacion
                    ? form_persona.precalificacion.estado
                    : "-"}
                </div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Observación</div>
                <div className="client-info-value">
                  {form_persona.precalificacion
                    ? form_persona.precalificacion.observacion
                    : "-"}
                </div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Garantes</div>
                <div className="client-info-value">
                  {form_persona.garantes
                    ? form_persona.garantes.length > 0
                      ? form_persona.garantes.length
                      : "No posee garantes"
                    : "No posee garantes"}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-7">
          <div className="credit-details-card">
            <div className="row">
              <div className="col-md-12 mb-3">
                <TextArea
                  key={"producto"}
                  sets={{
                    label: "Producto",
                    name: "producto",
                    placeholder: "Ingresar Producto",
                    valor: form_credito.producto,
                    rows: "2",
                    cols: "10",
                    requerido: false,
                    disabled: JSON.parse(id) ? true : false,
                  }}
                  onChange={onChange}
                />
              </div>
              <div className="col-md-12 mb-3">
                <TextArea
                  key={"comentarios"}
                  sets={{
                    label: "Comentario",
                    name: "comentarios",
                    placeholder: "Ingresar Comentario",
                    valor: form_credito.comentarios,
                    rows: "2",
                    cols: "10",
                    requerido: false,
                    disabled: JSON.parse(id) ? true : false,
                  }}
                  onChange={onChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="summary-info-card">
            <ul className="list-group">
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Saldo límite por cuota</div>
                <div className="client-info-value numeric-value">
                  {form_persona.creditos
                    ? formatNumber(SaldoCuotas(form_persona.creditos))
                    : formatNumber(0)}
                </div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Interés Punitorio</div>
                <div className="client-info-value">
                  {tasa_generica ? tasa_generica["PUNITORIO"].valor : 0}%
                </div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <div className="client-info-label">Interés Moratorio</div>
                <div className="client-info-value">
                  {tasa_generica ? tasa_generica["MORATORIA"].valor : 0}%
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-12 mb-3 d-flex justify-content-between align-items-center">
            <div className="credit-number-label">Nº de Crédito</div>
            <div className="credit-number-badge">{JSON.parse(id) ? id : "0000"}</div>
          </div>
          <div className="col-md-12">
            <div className="composition-table-header">
              Composición de la Cuota
            </div>
            <table className="composition-table composition-input-table">
              <thead>
                <tr>
                  <th>CAPITAL</th>
                  <th>INTERÉS</th>
                  <th>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      className="modern-credit-input"
                      type="number"
                      step="0.01"
                      name="capital"
                      value={form_credito.capital}
                      onChange={(event) => onChange(event)}
                      disabled={JSON.parse(id) ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="modern-credit-input"
                      type="number"
                      step="0.01"
                      name="interes"
                      value={form_credito.interes}
                      onChange={(event) => onChange(event)}
                      disabled={JSON.parse(id) ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="modern-credit-input"
                      type="text"
                      name="total"
                      value={formatNumber(form_credito.total)}
                      disabled={true}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-md-12 mb-3">
            <Input
              style={{ with: "10px" }}
              key={"fecha_otorgamiento"}
              sets={{
                label: "Fecha de otorgamiento",
                type: "date",
                name: "fecha_otorgamiento",
                placeholder: "Número cuotas",
                valor: form_credito.fecha_otorgamiento,
                requerido: true,
                disabled: JSON.parse(id) ? true : false,
              }}
              onChange={onChange}
            />
          </div>
          <div className="col-md-12 mb-3">
            <Input
              style={{ with: "10px" }}
              key={"vencimiento"}
              sets={{
                label: "Fecha Vto. 1 cuota",
                type: "date",
                name: "vencimiento",
                placeholder: "",
                valor: form_credito.vencimiento,
                requerido: true,
                disabled: JSON.parse(id) ? true : false,
              }}
              onChange={onChange}
            />
          </div>
          <div className="col-md-12 mb-3">
            <Input
              style={{ with: "10px" }}
              key={"cuotas"}
              sets={{
                label: "Número cuotas",
                type: "text",
                name: "cuotas",
                placeholder: "Número cuotas",
                valor: form_credito.cuotas,
                requerido: true,
                disabled: JSON.parse(id) ? true : false,
              }}
              onChange={onChange}
            />
          </div>
          <div className="col-md-12 mb-3">
            <Input
              style={{ with: "10px" }}
              key={"monto"}
              sets={{
                label: "Importe Capital",
                type: "text",
                name: "monto",
                placeholder: "Importe Crédito",
                valor: formatNumber(form_credito.monto),
                requerido: true,
                disabled: true,
              }}
              onChange={onChange}
            />
          </div>
          <div className="col-md-12 mb-3">
            <Input
              style={{ with: "10px" }}
              key={"interes_total"}
              sets={{
                label: "Importe a Devolver",
                type: "text",
                name: "interes_total",
                placeholder: "Importe a Devolver",
                valor: formatNumber(form_credito.interes_total),
                requerido: true,
                disabled: true,
              }}
              onChange={onChange}
            />
          </div>
          <div className="col-md-12 mb-3">
            <div className="col-sm-10">
              {form_persona.garantes
                ? form_persona.garantes.map((garante) => (
                    <div class="form-check text-center">
                      <input
                        class="form-check-input ms-1"
                        type="radio"
                        id="flexRadioDefault1"
                        name="garante"
                        value={garante.nombre}
                        onChange={(event) => onChange(event)}
                      />
                      <label class="form-check-label" for="flexRadioDefault1">
                        {garante.nombre + " " + garante.apellido}
                      </label>
                    </div>
                  ))
                : form_persona.garantes
                ? form_persona.garantes.map((garante, index) => (
                    <Input
                      key=""
                      sets={{
                        label: "Garante - " + (index + 1),
                        type: "text",
                        name: "saldo_limite_cuota",
                        placeholder: " ",
                        valor: garante.nombre + " " + garante.apellido,
                        disabled: true,
                      }}
                      onChange={onChange}
                    />
                  ))
                : ""}
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="unified-table-container">
            <table className="unified-table">
              <thead>
                <tr>
                  <th className="text-center"><div>Nº Cuota</div></th>
                  <th className="text-center"><div>Vto</div></th>
                  <th className="text-center"><div>Capital</div></th>
                  <th className="text-center"><div>Interés</div></th>
                  <th className="text-center"><div>Días de mora</div></th>
                  <th className="text-center"><div>Int Moratorio</div></th>
                  <th className="text-center"><div>Total a pagar</div></th>
                  <th className="text-center"><div>Deuda acumulada</div></th>
                </tr>
              </thead>
              <tbody>
                {form_credito.credito_detalle.map((detalle, index) => (
                  <tr key={index}>
                    <td className="text-center">{detalle.nro}</td>
                    <td className="text-center">{format(new Date(detalle.vto), "dd/MM/yyyy").toString()}</td>
                    <td className="text-end">
                      <span className="unified-money">
                        {formatNumber(detalle.capital)}
                      </span>
                    </td>
                    <td className="text-end">
                      <span className="unified-money">
                        {formatNumber(detalle.interes)}
                      </span>
                    </td>
                    <td className="text-center">
                      <span className={detalle.diferencia_dias > 0 ? "unified-badge unified-badge-warning" : "unified-badge unified-badge-secondary"}>
                        {detalle.diferencia_dias} días
                      </span>
                    </td>
                    <td className="text-end">
                      <span className={detalle.interes_punitorio > 0 ? "unified-money-negative" : "unified-money"}>
                        {formatNumber(detalle.interes_punitorio)}
                      </span>
                    </td>
                    <td className="text-end">
                      <span className="unified-money">
                        {formatNumber(parseFloat(detalle.total) + parseFloat(detalle.interes_punitorio))}
                      </span>
                    </td>
                    <td className="text-end">
                      <span className="unified-money">
                        {formatNumber(detalle.deuda)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-md-12 d-flex justify-content-center" style={{ marginTop: '24px', marginBottom: '24px' }}>
          <button
            className={JSON.parse(id) ? "save-credit-button d-none" : "save-credit-button"}
            name="guardar"
            onClick={(event) => onClick(event)}
            disabled={JSON.parse(id) ? true : false}
          >
            Guardar Crédito
          </button>
        </div>
      </div>
      </div>
    </div>
  );
};

export default FormCreditoEspecial;
